import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import userIcon from "../assets/header/ic_profile.png";
import { Link } from "react-router-dom";
import downCaret from "../assets/header/ic_dropdown.svg";
import classNames from "classnames";
import { onPushProfile, onLogOutCleverTap } from "../utils/events";
import { createCookie } from "../utils/helper";
import { connect } from "react-redux";
import { setProfile, resetProfile } from "../actions";
import client from "../utils/client";
import { resetWrp } from "../modules/home/actions";

class Avatar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      profile: null,
      showDropdown: false,
      location: this.props.location
    };
  }

  handleClick = () => {
    this.setState({
      showDropdown: !this.state.showDropdown,
    });
  };

  onLogout = (event) => {
    event.persist();
    onLogOutCleverTap();
    localStorage.clear();
    createCookie("windsEWorldAppLanguageCode", "en", "60");
    const reset = this.props;
    event.target.submit();
    reset && reset();
  };

  componentDidMount() {
    this.props.onInit(this.state.location);
  }

  render() {
    if (null != this.props.profile) {
      return (
        <li className="nav-item text-center" onClick={this.handleClick}>
          <div className="account-info">
            <img className="userIcon" src={userIcon} alt="Login" />
            <span className="nav-text">
              <span>
                {this.props.profile.name.substring(0, 10)}
              </span>
            </span>
            <img src={downCaret} style={{ display: "inline", height: "auto" }} alt="down caret" />
          </div>
          <div
            className={classNames("dropdown-menu", "dropdown-menu-right", {
              show: this.state.showDropdown,
            })}
            onMouseLeave={() => {
              this.setState({ showDropdown: false });
            }}
          >
            <Link className="dropdown-item dropdown-icons" to="/profile">
              <FormattedMessage id="navbar.profile" defaultMessage="Profile" />
            </Link>
            <Link className="dropdown-item dropdown-icons d-md-none" to="/orders">
              <FormattedMessage id="navbar.orders" defaultMessage="Orders" />
            </Link>
            <Link className="dropdown-item dropdown-icons" to="/wallet">
              <FormattedMessage id="navbar.wallet" defaultMessage="Wallet" />
            </Link>
            <Link className="dropdown-item dropdown-icons" to="/earnings">
              <FormattedMessage id="navbar.my-earnings" defaultMessage="My Earnings" />
            </Link>
            <Link className="dropdown-item dropdown-icons" to="/bookmarks">
              <FormattedMessage id="navbar.bookmarks" defaultMessage="Bookmarks" />
            </Link>
            <Link className="dropdown-item dropdown-icons" to="/refer-and-earn">
              <FormattedMessage id="navbar.refer-and-earn" defaultMessage="Refer & Earn" />
            </Link>
            <Link className="dropdown-item dropdown-icons" to="/winners">
              <FormattedMessage id="navbar.winners" defaultMessage="Winners" />
            </Link>
            <form
              action={`${process.env.REACT_APP_SSO_URL}/logout`}
              method="post"
              onSubmit={this.onLogout}
            >
              <span className="dropdown-item dropdown-icons" style={{padding:0}}>
                <input
                  type="submit"
                  value={this.props.intl.formatMessage({
                    id: "navbar.logout",
                    defaultMessage: "Logout",
                  })}
                  style={{
                    border: "none",
                    background: "transparent",
                    padding: "0.3rem 1.5rem",
                    width: "100%",
                    textAlign: "left"
                  }}
                />
              </span>
            </form>
          </div>
        </li>
      );
    }

    return (
      <li className="nav-item text-center">
        <a className="nav-link" href={`${process.env.REACT_APP_SSO_URL}/login`}>
          <div className="account-info">
            <img className="userIcon" src={userIcon} alt="Login" />
            <span className="nav-text">
              <FormattedMessage id="navbar.login" defaultMessage="Login" />{" "}
            </span>
            <img src={downCaret} style={{ display: "inline", height: "auto" }} alt="down caret" />
          </div>
        </a>
      </li>
    );
  }
}

function mapStateToProps(state) {
  return {
    profile: state.global.profile,
    location: state.location.formatted_location
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: (location) => {
      client
        .get("v1/profile?billing_email=true")
        .then((response) => {
          const responseData = response.data.data;
      dispatch(setProfile(responseData));
          onPushProfile(responseData, location);
        })
        .catch((error) => {
          dispatch(resetProfile());
          dispatch(resetWrp())
        });
    },
    // onInit: (location) => {
    //   const responseData = {
    //     "id": 14932,
    //     "name": "Vaishakh Devadiga",
    //     "mobile": "8277651147",
    //     "mobile_verified": true,
    //     "email": "t@gmail.com",
    //     "email_verified": true,
    //     "can_set_password": false,
    //     "gender": "Male",
    //     "dob": "1997-06-27",
    //     "state_id": 17,
    //     "state_name": "Karnataka",
    //     "profile_pic_url": "https://s3.ap-south-1.amazonaws.com/winds-staging/profile_pics/12005737166333fba1a7ddb.png",
    //     "referral_code": "b7o516",
    //     "referral_link": "https://winds.to/uo7C",
    //     "language": "en",
    //     "promotional_notifications_enabled": true,
    //     "is_verified": false,
    //     "has_verification_details": false,
    //     "verification_status": null,
    //     "verification_status_text": "Not Initiated",
    //     "can_add_update_verification_details": true,
    //     "last_login_at": "Tue, Feb 7, 2023 2:58 PM"
    //   }
    //   onPushProfile(responseData, location);
    //   dispatch(setProfile(responseData));
    // },
    reset: () => {
      dispatch(resetProfile());
      dispatch(resetWrp())
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Avatar));
